import { dateTimeToView } from "helpers/date";
import { divIcon } from "leaflet";
import React from "react";
import { Marker, Tooltip } from "react-leaflet";

export default function ServiceWorkPoint({ point, serviceWork }) {
    if (!point) {
        return null;
    }

    const options = {
        position: [point.location[1], point.location[0]],
        icon: divIcon({ className: "route-icon", iconSize: [30, 30], html: "<i class='icon-uEA97-wrench' />" }),
        zIndexOffset: 1000,
    };
    return (
        <Marker {...options}>
            <Tooltip
                className="map__tooltip-route-marker map__tooltip-route-marker--dark leaflet-tooltip--left-align leaflet-tooltip--light"
                direction="top"
            >
                <div className="pb-2 font-weight-bold">Сервисная работа</div>
                <div className="pb-1">
                    <b>{point.address}</b>
                </div>
                <div>
                    Плановая дата начала: <b>{dateTimeToView(serviceWork.startDate)}</b>
                </div>
                <div>
                    Плановая дата завершения: <b>{dateTimeToView(serviceWork.endDate)}</b>
                </div>
                {serviceWork.comment && (
                    <div>
                        Комментарий: <b>{serviceWork.comment}</b>
                    </div>
                )}
            </Tooltip>
        </Marker>
    );
}
